<!-- Format Selection Header -->
<h3
  class="tw-text-xl sm:tw-text-2xl tw-font-semibold tw-text-gray-900 dark:tw-text-gray-300 tw-my-0">
  Choose the right file format for your needs
</h3>

<!-- Format Cards -->
<div
  role="radiogroup"
  aria-label="Download file format"
  class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-4 md:tw-gap-3 tw-mb-8 tw-mt-6 tw-mr-1">
  <a
    *ngFor="let format of formats"
    role="radio"
    [attr.aria-checked]="selectedFormat === format.value"
    tabindex="0"
    (click)="selectFormat(format.value)"
    (keydown.enter)="selectFormat(format.value)"
    (keydown.space)="selectFormat(format.value); $event.preventDefault()"
    [ngClass]="{
        'tw-border-blue-500 tw-ring-2 tw-ring-blue-500': selectedFormat === format.value,
        'hover:tw-border-blue-200 dark:hover:tw-border-blue-700': selectedFormat !== format.value
      }"
    class="tw-bg-gray-100 dark:tw-bg-gray-800 tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-700 tw-rounded-xl tw-p-6 tw-cursor-pointer hover:tw-shadow-md dark:hover:tw-bg-gray-700 tw-transition-all tw-duration-200">
    <!-- Format Header -->
    <div class="tw-text-dark-light-dynamic tw-flex tw-items-center tw-gap-3 tw-mb-4">
      <mat-icon
        [ngClass]="{'tw-text-blue-500': selectedFormat === format.value}"
        class="tw-transition-colors tw-duration-200">
        {{selectedFormat === format.value ? 'radio_button_checked' : 'radio_button_unchecked'}}
      </mat-icon>
      <h4 class="tw-font-semibold tw-text-gray-900 dark:tw-text-gray-100 tw-my-0">
        {{format.label}}
      </h4>
    </div>

    <!-- Format Description -->
    <p class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 tw-mb-3">
      {{format.description}}
    </p>
    <a
      *ngIf="format.sampleLink"
      href="{{format.sampleLink}}"
      target="_blank"
      rel="noopener noreferrer"
      (click)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      (keydown.space)="$event.stopPropagation()"
      class="tw-text-blue-500 tw-text-sm tw-font-medium tw-mb-3 tw-flex tw-items-center tw-gap-1">
      <mat-icon class="tw-text-base tw-w-[18px]">open_in_new</mat-icon>
      View Sample {{format.fileTypeDescriptor}}
    </a>
    <!-- Features List -->
    <div class="tw-space-y-3">
      <ng-container *ngFor="let category of featureCategories">
        <ng-container *ngFor="let feature of category.features">
          <div *ngIf="getFeatureValue(format, feature.key)" class="tw-flex tw-items-center tw-gap-3 tw-text-sm">
            <mat-icon
              *ngIf="getFeatureIndicator(format, feature.key) === 'full'"
              class="tw-text-green-500 tw-text-base">
              check_circle
            </mat-icon>
            <mat-icon
              *ngIf="getFeatureIndicator(format, feature.key) === 'partial'"
              class="tw-text-blue-500 tw-text-base tw-font-bold">
              contrast
            </mat-icon>
            <mat-icon
              *ngIf="getFeatureIndicator(format, feature.key) === 'none'"
              class="tw-text-red-500 tw-text-base tw-font-bold">
              close
            </mat-icon>
            <span
              [class.tw-line-through]="getFeatureIndicator(format, feature.key) === 'none'"
              [class.tw-text-gray-400]="getFeatureIndicator(format, feature.key) === 'none'"
              class="tw-text-dark-light-dynamic tw-transition-colors tw-duration-200">
              {{feature.name}}: {{getFeatureValue(format, feature.key)}}
            </span>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </a>
</div>
